// extracted by mini-css-extract-plugin
export default {"container":"notification-popup-element_container__40Y+V","timerProgress":"notification-popup-element_timerProgress__v2OJG"};